import {
	ROUTE_NAMES_SOFTWARE_BACKLOG,
	ROUTE_NAMES_SOFTWARE_BOARDS,
	ROUTE_NAMES_ISSUE,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE,
	ROUTE_NAMES_RAPIDBOARD_BACKLOG,
	ROUTE_NAMES_RAPIDBOARD_BOARD,
	ROUTE_NAMES_SOFTWARE_CALENDAR,
	ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC,
	ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR,
	ROUTE_NAMES_SOFTWARE_LIST,
	ROUTE_NAMES_SOFTWARE_LIST_CLASSIC,
	ROUTE_NAMES_SOFTWARE_TIMELINE,
	ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE,
	ROUTE_NAMES_PROJECT_PAGES,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD,
	ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR,
} from '@atlassian/jira-common-constants/src/spa-routes';
import {
	useIsFirstActivationDateWithinLastMemo,
	useIsFirstActivationDateAfterOneDayMemo,
} from '@atlassian/jira-onboarding-core';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller';

// Search under `src/packages/router-routes` for the routes
const eligibleRoutes = [
	// Board View
	ROUTE_NAMES_SOFTWARE_BOARDS, // /jira/software/projects/:projectKey/boards/:boardId
	ROUTE_NAMES_RAPIDBOARD_BOARD, // /jira/software/c/projects/:projectKey/boards/:boardId
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD, // /jira/core/projects/:projectKey/board

	// Timeline View
	ROUTE_NAMES_SOFTWARE_TIMELINE, // /jira/software/projects/:projectKey/boards/:boardId/timeline
	ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC, // /jira/software/c/projects/:projectKey/boards/:boardId/timeline
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE, // /jira/core/projects/:projectKey/timeline

	// List View
	ROUTE_NAMES_SOFTWARE_LIST, // /jira/software/projects/:projectKey/list
	ROUTE_NAMES_SOFTWARE_LIST_CLASSIC, // /jira/software/c/projects/:projectKey/list
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST, // /jira/core/projects/:projectKey/list

	// Backlog View
	ROUTE_NAMES_SOFTWARE_BACKLOG, // /jira/software/projects/:projectKey/boards/:boardId/backlog
	ROUTE_NAMES_RAPIDBOARD_BACKLOG, //  /jira/software/c/projects/:projectKey/boards/:boardId/backlog
	// note: looks like JWM doesn't have a backlog view

	// Calendar View
	ROUTE_NAMES_SOFTWARE_CALENDAR, // /jira/software/projects/:projectKey/boards/:boardId/calendar
	ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC, // /jira/software/c/projects/:projectKey/boards/:boardId/calendar
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR, // /jira/core/projects/:projectKey/calendar

	// Issues View
	ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR, // /jira/software/projects/:projectKey/issues/:issueKey?
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC, // /jira/software/c/projects/:projectKey/issues/:issueKey?
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE, // /jira/core/projects/:projectKey/issues/:issueKey?
	ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR, // /issues/:issueKey?

	// Issue View
	ROUTE_NAMES_ISSUE, // /browse/:issueKey(\\w+-\\d+)(.*)?

	// Summary, Approvals, Form, Pages
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY, // /jira/core/projects/:projectKey/summary
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS, // /jira/core/projects/:projectKey/approvals
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM, // /jira/core/projects/:projectKey/form
	ROUTE_NAMES_PROJECT_PAGES, // /jira/core/projects/:projectKey/pages
];

export const useIsEligibleForDesShareLinkExperiment = () => {
	const isSiteAdmin = useIsSiteAdmin();
	const route = useCurrentRoute();
	const isFirstActivationDateWithinLast14Days = useIsFirstActivationDateWithinLastMemo({
		days: 14,
	});
	const isFirstActivationDateAfterOneDay = useIsFirstActivationDateAfterOneDayMemo();

	return (
		isSiteAdmin &&
		eligibleRoutes.includes(route.name) &&
		isFirstActivationDateWithinLast14Days &&
		isFirstActivationDateAfterOneDay
	);
};
